import React, { createRef, Component } from "react";
import {
  Map,
  WMSTileLayer,
  ScaleControl,
  Marker,
  GeoJSON,
  Popup as ReactPopup,
  withLeaflet,
} from "react-leaflet";
import { Button, Popup, Menu } from "semantic-ui-react";
import urls from "../../urls";
import L from "leaflet";
import Control from "react-leaflet-control";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { Slider } from 'react-semantic-ui-range'
import {
  faExpand,
  faWindowClose,
  faChartBar,
  faCompress,
  faGlobeAsia,
  faInfoCircle,
  faThList,
} from "@fortawesome/free-solid-svg-icons";
import MouseControl from "../../MousePosition";
// import file_heads from '../Helpers/file-tails'
import DateSlider from "./DateSlider";
import colors from "../../colors";

// import BaseMapList from '../../BaseMapList/BaseMapList'

import axios from "axios";
import domain from "../../domain";
import { OffCanvas, OffCanvasMenu } from "react-offcanvas";

import moment from "moment";
import { FadeLoader } from "react-spinners";

// import * as helpers from '../../helpers'
import DialogDefault from "react-leaflet-dialog";
// import MinimalWindow from "../../MessageBox/MinimalWindow";
import WMSNonTileLayer from "../../web_glacial/Components/WMSNonTileLayer";
library.add(
  faWindowClose,
  faChartBar,
  faExpand,
  faCompress,
  faGlobeAsia,
  faInfoCircle,
  faThList
);

// const { BaseLayer, Overlay } = LayersControl;
const crs = L.CRS.EPSG4326;

const style = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

var authType = "Basic";
var username = "NhpAdmin";
var password = "nhp@1234";
var basicAuth = authType + btoa(username + ":" + password);
axios.defaults.headers.common["Authorization"] = basicAuth;
let count = 0,
  count1 = 0;

const Dialog = withLeaflet(DialogDefault);

class MapView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      minZoom: 3,
      maxZoom: 15,
      zoom: 4,
     center: [25.12539, 80.00164],
    //center: [18.435437036956206,79.41566519637729],

      latlng: { lat: null, lng: null },
      
      pointInfo: null,

      wms_url: `${domain.Geoserver}/nhp_flood/wms`,
      legend: null,
      legendVisible: true,
      visibleRight: false,
      isExpand: false,
      showInfo: true,
      loading: false,
      forecast: false,
      modal: false,
      bottomlayers: false,
      layers: urls.map_layer,
      url: urls.bhuvan_map,
      catchmentfilename:"#",
      baseLayers: false,
      baselayerselected: "Map",
      informationVisible: true,
      layerloading: false,
      markerenable: true,
      isMenuOpened: true,
      legend_array_overlay: {
        Basin:
               `${domain.Basin_legend}`,
        HO:
          `${domain.HO_legend}`,
      },
      
      popup: {
        river_name: null,
        station_name: null,
        highest: null,
        position: null,
      },
    };
   
  }
  mapRef = createRef();
  tileRef = createRef();
  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };




  async getLegendGraphic1() {

    let request = "GetLegendGraphic";
    let format = "image/png";
    let width = 40;
    let height = 10;
    let layer="nhp_flood:nhp_flood:flood_ind_godavari_styles";
    let wms_url=this.state.wms_url

    let img_src = `${wms_url}?request=${request}&layer=${layer}&format=${format}&width=${width}&height=${height}&legend_options=dpi:100`;
console.log("lllllegend")
    return img_src;
  }
  
  getLegendGraphic_basic = (e) => {
    let wms_url = this.state.wms_url;
    let title;
    console.log("e.name",e.name);
    let legend_array_overlay = { ...this.props.legend_array_overlay };
    let layer = "nhp_flood:nhp_fews_" + this.props.basinselected + "_" + e.name;
    console.log("layer, e.name",layer);
    this.getLegendGraphic(wms_url, layer).then((legend) => {
      //  this.props.setLegend(legend)
      legend_array_overlay[e.name] = legend;
      console.log("legend name",legend_array_overlay);
      this.setState({
        legend_array_overlay: legend_array_overlay,
        legend_overlay: legend,
        legend_title: title,
      });
    });
  };


  
  getLegendGraphic_remove = (e) => {
    // let wms_url =this.state.wms_url
    // console.log(e.name)
    // let layer='nhp_irrigation:'+e.name.toLowerCase().split(' ').join('_')
    let name = e.name;
    let legend_array_overlay = { ...this.state.legend_array_overlay };
    console.log(legend_array_overlay);
    delete legend_array_overlay[name];
    console.log(legend_array_overlay);

    this.setState({
      legend_array_overlay: legend_array_overlay,
      legend_overlay: null,
    });
  };
  loading = (e) => {
    this.setState({
      layerloading: true,
    });
    // console.log(e)
  };
  load = (e) => {
    this.setState({
      layerloading: false,
    });
  };
  

  resetZoom = () => {
    const leafletMap = this.mapRef.current.leafletElement;
    leafletMap.setZoom(this.state.zoom);
    leafletMap.panTo(new L.LatLng(25.12539, 80.00164));
  };
  printPreview = () => {
    // const leafletMap = this.mapRef.current.leafletElement
    // L.PrintPreview().addTo(leafletMap);
  };

  displayInformation = () => {
    this.setState({ informationVisible: !this.state.informationVisible });
  };
  showInfo = () => {
    this.setState({ showInfo: !this.state.showInfo });
  };

  handleMark = () => {
    this.setState({ markerenable: true });
  };





  onMouseOver = (e) => {
    console.log(e);

    axios
      .get(`${domain.DBServer}/get-point-info/${e.latlng.lat}/${e.latlng.lng}`)
      .then((result) => {
        if (result.data.length === 1) {
          const leafletMap = this.mapRef.current.leafletElement;
          this.setState({
            latlng: e.latlng,
            // latlng:{lat: L.Projection.LonLat.project(e.latlng).y, lng:L.Projection.LonLat.project(e.latlng).x}
            // showInfo:true,
          });
          console.log(e.latlng);
          //  console.log(e)
          // this.props.setLatLng({lat: L.Projection.LonLat.project(e.latlng).y, lng:L.Projection.LonLat.project(e.latlng).x})
          this.props.setLatLng(e.latlng);

          let active_layer =
            this.props.selected !== null
              ? this.props.selected.toLowerCase().split(" ").join("-") +
                ":" +
                this.props.selectedLayer[this.props.selected]
              : "india states";
          console.log(active_layer);
          let wms_url =
            this.props.selected !== null
              ? `${
                  domain.Geoserver
                }/nhp_fews_${this.props.selected
                  .toLowerCase()
                  .split(" ")
                  .join("-")}/wms`
              : this.state.wms_url_default;

          let containerPoint = e.containerPoint;

          let bounds = leafletMap.getBounds();
          let bbox = bounds.toBBoxString();
          // let sw = crs.project(bounds.getSouthWest())
          // let ne = crs.project(bounds.getNorthEast())
          // let bboxStr = `${sw.x},${sw.y},${ne.x},${ne.y}`
          let width = leafletMap.getSize().x;
          let height = leafletMap.getSize().y;
          //    console.log(bounds)
          this.props.setOnClickDetails({
            xContainerPoint: containerPoint.x,
            yContainerPoint: containerPoint.y,
            height: height,
            width: width,
            bbox: bbox,
          });

          // this.props.getFeatureInfo('nhp_snowcomponent:hkh_subbasins_wgs84', this.state.wms_url_default, containerPoint.x, containerPoint.y, height, width,bbox).then((result)=>{

          //         if(result.data&&result.data.features[0]){

          //             this.props.setStateInfo(
          //                 result.data.features[0]

          //             )
          //         }else{
          //             this.props.setStateInfo(null)
          //         }

          // })
          this.props
            .getFeatureInfo(
              `${domain.DBServer}/get-himalayan-basininfo/${e.latlng.lng}/${e.latlng.lat}`
            )
            .then((result) => {
              console.log(result.data);
              if (result.data) {
                this.props.setStateInfo(result.data[0]);
              } else {
                this.props.setStateInfo(null);
              }
            });

          if (this.props.selected.toLowerCase() === "snow cover fraction") {
            // this.props.makeChartDataNDays(active_layer, wms_url, containerPoint.x, containerPoint.y, height, width,bbox)
            this.props.makeChartDataAvailableDaysWithDateCats(
              active_layer,
              wms_url,
              L.Projection.LonLat.project(e.latlng).y,
              L.Projection.LonLat.project(e.latlng).x,
              height,
              width,
              bbox
            );
            this.props.handleVisibleGraphPanelOnMapClick();
          }
          //  this.props.makeChartDataAvailableDaysWithDateCats(active_layer, wms_url, L.Projection.LonLat.project(e.latlng).y, L.Projection.LonLat.project(e.latlng).x, height, width,bbox)
          // if(this.props.selected!==null){

          // }
        } else {
          this.setState({
            markerenable: false,
          });
        }
      });
  };

  componentDidUpdate(prevProps, PrevState) {
    console.log(this.props);
    const map = this.mapRef.current.leafletElement;
    if (this.props.selectedLayer !== prevProps.selectedLayer) {
      // this.props.selectedLayer
      // let layer =
      //   this.props.selected !== null
      //     ? "nhp_flood:" + this.props.selectedLayer[this.props.selected]
      //     : "india states";

      // let wms_url =
      //   this.props.selected !== null
      //     ? `${domain.Geoserver}/nhp_flood/wms`
      //     : this.state.wms_url;
      const imf_colors_range = [
        "#ffffff",
        "#9A95FB",
        "#7E78FA",
        "#6C65FA",
        "#514AF9",
        "#413CF9",
        "#2E2BF8",
        "#131AF8",
        "#0010F6",
        "#000EE0",
        "#000CD0",
        "#000BC1",
        "#0108A9",
        "#0109A2",
        "#03068C",
        "#030580",
        "#030476",
        "#04036B",
        "#040363",
        "#04024F",
        "#02024A",
      ];
      const imf_grades = [
        " 0",
        " 0.1-1",
        " 1-2",
        " 2-3",
        " 3-4",
        " 4-5",
        " 5-6",
        " 6-7",
        " 7-8",
        " 8-9",
        " 9-10",
        " 10-12",
        " 12-14",
        " 14 -16",
        " 16-18",
        " 18-20",
        " 20-25",
        " 25-30",
        " 30-35",
        " 35-40",
        " 40-45",
      ];
      let wms_url =
      this.props.selected !== null ? `${domain.Geoserver}/nhp_flood/wms` : null;
      let layer =
      this.props.selected !== null
        ? "nhp_flood:nhp_fews_"+    
        
        this.props.selectedLayer[this.props.selected]
        : null;
      console.log(this.props.selectedLayer[this.props.selected]);
      let imf_img = imf_grades.map((value, key) => {
        // console.log(index)
        return (
          <React.Fragment>
            <i key={key} style={{ background: `${imf_colors_range[key]}` }}></i>{" "}
            {value} <br />{" "}
          </React.Fragment>
        );
      });
    
      // if (this.props.basinselected === "Godavari")
      //   map.fitBounds([
      //     [17.449807693679471, 80.2246563430968536],
      //     [18.680679957125399, 81.4385759743300497]
      //   ]);
      // else if (this.props.basinselected === "Tapi") {
      // }


      

      if (
        this.props.in_boundary !== null &&
        this.props.selectedLayer !== "basin"
      ) {
        // var poly=L.Polygon(this.props.in_boundary.features[0].geometry.coordinates)
        let poly = this.props.in_boundary.features[0].geometry.coordinates[0];
        console.log(poly[1][1]);
      
       // this.getLegendGraphic(wms_url, layer).then((legend) => {
        //  console.log(legend);
        //  this.props.setLegend(legend);
       // });
    
      //  this.props.setLegend(imf_img);
        map.fitBounds([
         [poly[2][1], poly[0][0]],
          [poly[1][1], poly[1][0]],
       ]);
      }
      if (this.props.zoom_reset === 5) {
        map.setZoom(this.props.zoom_reset);
      }
      //map.fitBounds(map.getBounds())
      // this.props.makeChartDataAvailableDaysWithDateCats()
    }

    if (this.props.basinoverlays !== prevProps.basinoverlays) {
    }
    // const leafletMap = this.mapRef.current.leafletElement
    // leafletMap.invalidateSize()

    if (this.props.visibleLeft === false) {
      const leafletMap = this.mapRef.current.leafletElement;
      leafletMap.invalidateSize();
    }
    if (this.props.visibleGraphPanel === false) {
      const leafletMap = this.mapRef.current.leafletElement;
      leafletMap.invalidateSize();
    }
    if (this.props.visibleGraphPanel === false) {
      const leafletMap = this.mapRef.current.leafletElement;
      leafletMap.invalidateSize();
    }
  }

  async getLegendGraphic(wms_url, layer) {
    let request = "GetLegendGraphic";
    let format = "image/png";
    let width = 40;
    let height = 10;

    let img_src = `${wms_url}?request=${request}&layer=${layer}&format=${format}&width=${width}&height=${height}&legend_options=dpi:100`;

    return img_src;
  }

  handleAnimationChangeRight = () => {
    this.setState({
      visibleRight: !this.state.visibleRight,
      // width: !this.state.visible?"500%":"100%"
    });
  };
  handleExpand = () => {
    this.setState({
      isExpand: !this.state.isExpand,
    });
  };

  

 

  highlightHimalayan = (feature, layer) => {
    const map = this.mapRef.current.leafletElement;
    // layer.on({

    // })
    layer.setStyle({
      weight: 3,
      color: "#0000FF",
      fillOpacity: 0,
    });
   // map.fitBounds(layer.getBounds());
   
   map.flyToBounds(layer.getBounds(), {
    animate: true, // Enables animation
    duration: 1,   // Duration in seconds (adjust as needed)
    easeLinearity: 0.25, 
    // maxZoom:6// Controls easing (default is 0.25, lower makes it smoother)
  //  padding: [50, 50] // Adds some padding around the bounds
  });

  };

  highlightState = (feature, layer) => {
    const map = this.mapRef.current.leafletElement;
    console.log(feature)
    layer.setStyle({
      weight: 3,
      color: "#8856a7",
      fillOpacity: 0,
    });
    //map.fitBounds(layer.getBounds());
    
    map.flyToBounds(layer.getBounds(), {
      animate: true, // Enables animation
      duration: 1,   // Duration in seconds (adjust as needed)
      easeLinearity: 0.25, 
       //maxZoom:6// Controls easing (default is 0.25, lower makes it smoother)
    //  padding: [50, 50] // Adds some padding around the bounds
    });
  
  };
  highlightState = (feature, layer) => {
    const map = this.mapRef.current.leafletElement;
    // console.log
    if(feature.properties.per_inunda<=0)
    {
    layer.setStyle({
      weight: 3,
      fill: "#8856a7",
      fillOpacity: 1,
    });
  }
  else if(feature.properties.per_inunda>10)
    {
    layer.setStyle({
      weight: 3,
      fill: "#FF00FF",
      fillOpacity: 1,
    });
  }
   // map.fitBounds(layer.getBounds());
   
   map.flyToBounds(layer.getBounds(), {
    animate: true, // Enables animation
    duration: 1,   // Duration in seconds (adjust as needed)
    easeLinearity: 0.25, 
    // maxZoom:6// Controls easing (default is 0.25, lower makes it smoother)
  //  padding: [50, 50] // Adds some padding around the bounds
  });

  };

  highlightBasin = (feature, layer) => {
    const map = this.mapRef.current.leafletElement;
    console.log(feature)
    console.log(map);
    layer.setStyle({
      weight: 0,
      color: "#FFFFFf",
      fillOpacity: 0,
    });

    //map.fitBounds(layer.getBounds());
    
    map.flyToBounds(layer.getBounds(), {
      animate: true, // Enables animation
      duration: 1,   // Duration in seconds (adjust as needed)
      easeLinearity: 0.25, 
     //  maxZoom:6// Controls easing (default is 0.25, lower makes it smoother)
    //  padding: [50, 50] // Adds some padding around the bounds
    });
  
  };
  
  highlightHO = (feature, layer) => {
    const map = this.mapRef.current.leafletElement;
    console.log(map);
    layer.setStyle({
      weight: 0,
      color: "#0000FF",
      fillOpacity: 0,
    });

    //map.fitBounds(layer.getBounds());
    
    map.flyToBounds(layer.getBounds(), {
      animate: true, // Enables animation
      duration: 1,   // Duration in seconds (adjust as needed)
      easeLinearity: 0.25, 
      // maxZoom:6// Controls easing (default is 0.25, lower makes it smoother)
    //  padding: [50, 50] // Adds some padding around the bounds
    });
  
  };

  handleClick_bottom = (value) => {
    console.log(value);
  };
  handleClick_tools = (value) => {
    if (value === "about") {
      this.setState({
        informationVisible: true,
      });
      // this.props.handleChangeHelp(true)
    }
  };
  highlightIN = (feature, layer) => {
    const map = this.mapRef.current.leafletElement;
    console.log(map);
    layer.setStyle({
      weight: 0,
      color: "#0000FF",
      fillOpacity: 0,
    });

    //map.fitBounds(layer.getBounds());
    
    map.flyToBounds(layer.getBounds(), {
      animate: true, // Enables animation
      duration: 1,   // Duration in seconds (adjust as needed)
      easeLinearity: 0.25, 
     //  maxZoom:6// Controls easing (default is 0.25, lower makes it smoother)
    //  padding: [50, 50] // Adds some padding around the bounds
    });
  
  };
  highlightPoints_gd = (feature, latlng) => {
    let label = String(feature.properties.name);
    console.log(label);
    return L.circleMarker(latlng, {
      radius: 8,
      fillColor: "#d7191c",
      color: "#d7191c",
      weight: 5,
      opacity: 1,
      fillOpacity: 0.8,
    });
  };

  
  highlightPoints_tp = (feature, latlng) => {
    let label = String(feature.properties.name);
    console.log(label);
    return L.circleMarker(latlng, {
      radius: 4,
      fillColor: "#d7191c",
      color: "#d7191c",
      weight: 10,
      opacity: 1,
      fillOpacity: 0.8,
    });
  };
  highlightPoints_tp_click = (feature, layer) => {
    console.log(layer);
    layer.on("click", this.addPopup);
  };
  highlightPoints_gd_click = (feature, layer) => {
    console.log(layer);
    layer.on("click", this.addPopup);
  };
  addPopup = (e) => {
    console.log(e.target);
    this.setState({
      popup: {
        station_name: e.target.feature.properties.name,
        river_name: e.target.feature.properties.river_name,
        highest: e.target.feature.properties.hfd_cumecs,
        position: e.latlng,
      },
    });
    L.DomEvent.stopPropagation(e);
  };

  handleClick = (e) => {
    console.log(e.latlng);
  };
  markerClick = (lat, long, basin, site_name) => {
    let poistion = [lat, long];
    console.log(basin, site_name);
    if (basin === "Godavari") {
      axios
        .get(`${domain.DBServer}/fetch-station-info-gd/${site_name}`)
        .then((result) => {
          if (result) {
            this.setState({
              popup: {
                station_name: result.data[0].site_name,
                river_name: result.data[0].river_name,
                highest: result.data[0].hfd_max,
                position: poistion,
              },
            });
          }
        });
    } else if (basin === "Tapi") {
      axios
        .get(`${domain.DBServer}/fetch-station-info-tp/${site_name}`)
        .then((result) => {
          if (result) {
            this.setState({
              popup: {
                station_name: result.data[0].site_name,
                river_name: result.data[0].river_name,
                highest: result.data[0].hfd_max,
                position: poistion,
              },
            });
          }
        });
    }
  };
  fitBounds_in = () => {
    console.log("here");
    const map = this.mapRef.current.leafletElement;
    // console.log(map)
    // console.log(L.latLngBounds([[ 17.4498076936794710,80.2246563430968536],[ 18.6806799571253990,81.4385759743300497]]))
    //map.fitBounds(map.getBounds());
    
    map.flyToBounds(map.getBounds(), {
      animate: true, // Enables animation
      duration: 1,   // Duration in seconds (adjust as needed)
      easeLinearity: 0.25, 
      // maxZoom:6// Controls easing (default is 0.25, lower makes it smoother)
    //  padding: [50, 50] // Adds some padding around the bounds
    });
  
  };
  displayBaseLayers = () => {
    console.log("base layers");
    this.setState({
      baseLayers: !this.state.baseLayers,
    });
  };
  changeBaseLayer = (event) => {
    let layers, url;
    //  this.findActiveLayers()
    console.log(event.target);
    if (event.target.value === "Map") {
      url = urls.bhuvan_map;
      layers = urls.map_layer;
    } else if (event.target.value === "Satellite") {
      layers = urls.s_layer;
      // url='http://192.168.192.103:8080/geoserver/cite/wms'
      url = urls.satellite;
    }

    this.setState({
      baselayerselected: event.target.value,
      url: url,
      layers: layers,
    });
  };



  render() {
    let test, test1;
    console.log(this.props);
    if( this.props.selectedLayer !== "basin" &&
      this.props.catchmentfilename!=="#")

      {
        console.log("sdfsdfdsfdsfsdfsd",this.props.selectedLayer)
         //  this.props.setLegend(imf_img);
        //map.fitBounds([
       
          //[18.435437036956206,79.41566519637729]
          //[19.736157338327875,80.52499510760359]    
      // ]);
      // map.setCenter([18.435437036956206,79.41566519637729],10)
      
    }

    if (this.props.geojsonadd) {
      count = count + 1;
    }
    if (this.props.himalayan_boundary) {
      count1 = count1 + 1;
    }
    console.log(this.props.legend_array_overlay);
    delete L.Icon.Default.prototype._getIconUrl;
    //  console.log(this.state.graphdata)
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
      iconUrl: require("leaflet/dist/images/marker-icon.png"),
      shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    });

    if (this.props.selectedLayer[this.props.selected]) {
      let value = this.props.selectedLayer[this.props.selected];
      // test = moment(value.split("_")[1],""
      test1 = value.split("_")[0];
      console.log(value.split("_")[1]);

      //  if(test1==='fim')
      // {
      //     label =
      // }
    }

    console.log(test);
    // console.log(this.props.basinoverlays)
    let legend_bar, legend_bar1;

    if (this.props.legend_array_overlay) {
      console.log("overlay",this.props.legend_array_overlay);
      legend_bar = Object.keys(this.props.legend_array_overlay).map((key) => {
        return (
          <React.Fragment>
            <h6 style={{ margin: "0px", textAlign: "left" ,fontWeight:"bold"}}>
              {key === "HO" ? "Hydro. Obser. Station" : key }
              </h6>
            
            
            <img src={this.props.legend_array_overlay[key]} alt=""></img>
          
            
            
            

          </React.Fragment>
        );
      });
    }
    if (this.props.catchmentfilename!=='#') {
      console.log("overlay",this.props.legend_array_overlay);
      legend_bar1 = 
        
          <React.Fragment>
            <h6 style={{ margin: "0px", textAlign: "left", fontWeight: "bold", float: "left" }}>
          Inundation
        </h6>
        <span style={{ float: "left", marginLeft: "10px", fontWeight: "normal" }}>
          Depth (m)
        </span>   
              

<img src={ `${this.state.wms_url}?request=GetLegendGraphic&layer=${"nhp_flood :" + this.props.catchmentfilename}&format=image/png&width=10&height=10&legend_options=dpi:100`} alt="Inundation Legend" />}
          </React.Fragment>
      
     
    }
    
    

    return (
      <Map
        ref={this.mapRef}
        // ref={m => { this.leafletMap = m }}
        center={this.state.center}
        onclick={this.props.selected === "Hydrograph" ? this.handleClick : null}
        // onpreclick
        minZoom={this.state.minZoom}
        maxZoom={this.state.maxZoom}
        zoom={this.state.zoom}
        onoverlayadd={this.getLegendGraphic_basic}
        onoverlayremove={this.getLegendGraphic_remove}
        style={{ backgroundColor: "#fff" }}
        attributionControl={false}
        // loadingControl={true}
        // style={{ height: '100vh', width: '100vh' }}
        crs={crs}
      >
       {
         this.props.villageaffected?
         <WMSTileLayer
         url={`${domain.Geoserver}/nhp_flood/wms`}
         layers={"nhp_flood :Villages_Affected_gcs" }
         format="image/png"
         zIndex={11}
         // key={key}
         tiled={false}
         transparent={true}
         onloading={this.loading}
         onload={this.load}
       />:
         null
       }
        {this.state.baselayerselected !== null ? (
          <WMSTileLayer
            ref={this.tileRef}
            layers={this.state.layers}
            // url='http://192.168.192.103:8080/geoserver/cite/wms'
            url={this.state.url}
            format="image/png"
            transparent={true}
            // crs={ crs}
            zIndex={1}
            onloading={this.loading}
            onload={this.load}
          />
        ) : null}

       

          {this.props.catchmentfilename!== "#" ? (
            


          
          <WMSTileLayer
            url={`${domain.Geoserver}/nhp_flood/wms/`}
            layers={"nhp_flood :" + this.props.catchmentfilename}
            format="image/png"
            zIndex={10}
          
            // key={key}
            tiled={false}
            transparent={true}
            onloading={this.loading}
            onload={this.load}

           
          
          />
          ) : null}
           

    
        {this.props.selected === "basin" ? (
          <WMSTileLayer
            url={`${domain.Geoserver}/nhp_flood/wms`}
            layers={"nhp_flood :nhp_fews_" + this.props.basinselected + "_Basin"}
            format="image/png"
            zIndex={11}
            // key={key}
            tiled={false}
            transparent={true}
            onloading={this.loading}
            onload={this.load}
          />
        ) : null}
        
        {this.props.basinoverlays
          ? this.props.basinoverlays.map((layer, key) => (
              <WMSTileLayer
                url={`${domain.Geoserver}/nhp_flood/wms`}
                layers={
                  layer.isChecked
                    ? "nhp_flood" +
                      ":" +"nhp_fews_"+
                      this.props.basinselected +
                      "_" +
                      layer.value
                    : null
                }
                format="image/png"
                zIndex={11}
                key={key}
                tiled={false}
                transparent={true}
                onloading={this.loading}
                onload={this.load}
              />
            ))
          : null}{" "}

              
        {/* {this.props.selected !== null ? this.fitBounds_in : null} */}
        





        {/*
        {this.props.selected !== null && this.props.selected !== "basin" ? (
          <WMSTileLayer
            url={`${domain.Geoserver}/nhp_flood/wms`}
            layers={
              "nhp_flood:" + this.props.selectedLayer[this.props.selected]
            }
            format="image/png"
            zIndex={11}
            transparent={true}
            onloading={this.loading}
            onload={this.load}

            // bbox={80.2246563430968536,17.4498076936794710 : ,18.6806799571253990}
            // minZoom={8}
            // bbox={17.4498076936794710,80.2246563430968536, 18.6806799571253990,81.4385759743300497}
            // opacity={1}
          />
        ) : null}
          */}
        {this.props.stateInfo !== null ? (
          <GeoJSON
            ref="geojson"
            key={this.props.stateInfo.key}
            data={this.props.stateInfo.geojson}
            onEachFeature={this.highlightState}
            crs={crs}
          />
        ) : null}
        {this.props.himalayan_boundary !== null ? (
          <GeoJSON
            ref="geojson"
            //  key={count1+1}
            data={this.props.himalayan_boundary}
            onEachFeature={this.highlightHimalayan}
            crs={crs}
          />
        ) : null}
     
        {this.props.geojsonadd !== null ? (
          <GeoJSON
                           ref="geojson"
            key={this.props.geojsonadd.features[0].id}
            data={this.props.geojsonadd}
            onEachFeature={this.highlightBasin}
            // crs={crs}
            // zIndex={10}
            // transparent={true}
          />
        ) : null}
        {!this.state.markerenable ? (
          <Dialog
            ref={(ref) => {
              this.dialog = ref;
            }}
            id="dialog1"
            size={[300, 200]}
            onClosed={this.handleMark}
            position="topleft"
            anchor={[250, 250]}
          >
            {/* <MinimalWindow
              info="Click any where inside india boundary"
              title="Information "
            /> */}
          </Dialog>
        ) : null}
        <Marker
          position={
            this.state.latlng.lat && this.state.latlng.lng
              ? [this.state.latlng.lat, this.state.latlng.lng]
              : [0, 0]
          }
        />
        {this.state.layerloading ? (
          <Control position="topleft">
            <div style={style}>
              <FadeLoader
                height="15"
                radius="3"
                margin="3"
                width="10"
                // css={override}
                sizeUnit={"px"}
                // size={150}
                color={"#123abc"}
                loading={this.state.layerloading}
              />
            </div>
          </Control>
        ) : null}
        <Control position="topleft" className="box-header">
          <Popup
            trigger={
              <Button
                size="tiny"
                onClick={this.resetZoom}
                compact
                style={{ padding: "8px" }}
              >
                <FontAwesomeIcon icon="globe-asia" size="lg" />
              </Button>
            }
            position="right center"
          >
            <Popup.Content>Reset Zoom</Popup.Content>
          </Popup>
        </Control>
        {!this.props.visibleGraphPanel &&
        test1 !== "in" &&
        this.props.series !== null ? (
          <Control position="bottomright">
            <Popup
              trigger={
                <Button
                  onClick={this.props.toggleVisibleGraphPanel}
                  secondary
                  style={{ backgroundColor: colors.graphical  }}
                  compact
                  size="medium"
                >
                  <FontAwesomeIcon icon="chart-bar" size="lg" />
                </Button>
              }
              position="left center"
            >
              <Popup.Content>Graphical Analysis</Popup.Content>
            </Popup>
          </Control>
        ) : null}
         {!this.props.visibleGraphPanel &&
        test1 !== "in" &&
        this.props.series_hd !== null ? (
          <Control position="bottomright">
            <Popup
              trigger={
                <Button
                  onClick={this.props.toggleVisibleGraphPanel_hd}
                  secondary
                  style={{ backgroundColor: colors.graphical  }}
                  compact
                  size="medium"
                >
                  <FontAwesomeIcon icon="chart-bar" size="lg" />
                </Button>
              }
              position="left center"
            >
              <Popup.Content>Graphical Analysis</Popup.Content>
            </Popup>
          </Control>
        ) : null}
        {window.innerWidth>1000?
        <Control position="topleft">
          <Button
            onClick={this.props.handleAnimationChange}
            secondary
            style={{ backgroundColor: colors.sidebar, marginLeft: "-10px" }}
            attached="right"
            compact
            size="mini"
          >
            <FontAwesomeIcon icon="th-list" size="sm" />
          </Button>
        </Control>: <Control position="bottomleft">
          <Button
            onClick={this.props.handleAnimationChange}
            secondary
            style={{ backgroundColor: colors.sidebar, marginLeft: "-10px" }}
            attached="right"
            compact
            size="mini"
          >
            <FontAwesomeIcon icon="th-list" size="sm" />
          </Button>
        </Control>}

        <MouseControl position="bottomleft" />
        <Control
          position="bottomleft"
          style={{ pointerEvents: "auto", cursor: "auto" }}
        >
          {this.props.slider ? (
            <DateSlider {...this.props.sliderOptions} />
          ) : null}
        </Control>
        <ScaleControl metric={true} className="toolbar" />
        <Control position="topright">
          <OffCanvas
            width={200}
            transitionDuration={300}
            effect={"overlay"}
            style={{ cursor: "move" }}
            isMenuOpened={this.state.isMenuOpened}
            position={"right"}
          >
            <OffCanvasMenu
              style={{
                alignContent: "center",
                backgroundColor: "rgb(255,255,255)",
                borderColor: "blue",
                top: "10px",
                marginRight: "10px",
              }}
            >
              <div style={{ background: colors["final_side"] }}>
                <Menu.Item
                  as="div"
                  onClick={this.displayBaseLayers}
                  style={{ textAlign: "center", marginLeft: `5px` }}
                >
                  <div style={{ display: "flex" }}>
                    <div
                      style={{
                        width: "80%",
                        color: colors.textcolor,
                        fontSize: "small",
                        cursor: "default",
                      }}
                    >
                      Base Layers
                    </div>
                    <div
                      style={{
                        textAlign: "right",
                        width: "20%",
                        marginRight: "10px",
                      }}
                    >
                      {this.state.baseLayers ? (
                        <FontAwesomeIcon icon="angle-down" />
                      ) : (
                        <FontAwesomeIcon icon="angle-right" />
                      )}
                    </div>
                  </div>
                </Menu.Item>
              </div>
              {this.state.baseLayers ? (
                <div>
                  <input
                    type="radio"
                    name="baselayer"
                    value="Satellite"
                    checked={this.state.baselayerselected === "Satellite"}
                    onChange={this.changeBaseLayer}
                  />{" "}
                  Satellite <br />
                  <input
                    type="radio"
                    name="baselayer"
                    value="Map"
                    checked={this.state.baselayerselected === "Map"}
                    onChange={this.changeBaseLayer}
                  />{" "}
                  Map
                </div>
              ) : null}

              <div style={{ background: colors["final_side"] }}>
                <Menu.Item
                  as="div"
                  onClick={this.props.displayLegend}
                  style={{ textAlign: "center", marginLeft: `5px` }}
                >
                  <div style={{ display: "flex" }}>
                    <div
                      style={{
                        width: "80%",
                        color: colors.textcolor,
                        fontSize: "small",
                        cursor: "default",

                      }}
                    >
                      Legend
                    </div>
                    <div
                      style={{
                        textAlign: "right",
                        width: "20%",
                        marginRight: "10px",
                      }}
                    >
                      {this.props.legendVisible ? (
                        <FontAwesomeIcon icon="angle-down" />
                      ) : (
                        <FontAwesomeIcon icon="angle-right" />
                      )}
                    </div>
                  </div>
                </Menu.Item>
              </div>

              {this.props.legendVisible ? (
                <React.Fragment>
                  {/* <center style={{  backgroundColor:colors.final_side_sub}}> */}
                  <center>
                    {test1 === "fim" &&
                    this.props.legend !== null &&
                    this.props.selected !== "#" ? (
                      <div className="info legend">
                        <p style={{ fontWeight: "bolder", fontSize: "14px" }}>
                          Inundation Map <br />
                          {moment(
                            this.props.selectedLayer[this.props.selected].split(
                              "_"
                            )[1],
                            "DDMMYYYY"
                          ).format("DD MMM YYYY")}{" "}
                          {this.props.selectedLayer[this.props.selected]
                            .split("_")[2]
                            .substring(0, 2)}{" "}
                          Hr (in m)
                        </p>
                      
                        <img src={this.props.legend} alt="" />
                      </div>
                    ) : null}
           

   {this.props.village_legend===null?
                    legend_bar
                    :null}
                    <br/>
                    {this.props.village_legend?   <img src={this.props.village_legend} alt="" />:null}
                    {this.props.catchmentfilename !== '#' ? (
                      
                        legend_bar1
                      
                    ) : null}
                    <br/>
                    <br/>
                  </center>
                </React.Fragment>
              ) : null}
            </OffCanvasMenu>
          </OffCanvas>
        </Control>
        {this.state.popup.station_name !== null ? (
          <ReactPopup
            position={this.state.popup.position}
            key={`popup-${this.state.popup.station_name}`}
            className="request-popup"
          >
            <div class="modalwindow">
              <div class="modalheader">Station Details</div>
              <div class="modalbox">
                Station Name : {this.state.popup.station_name} <br />
                River Name : {this.state.popup.river_name}
                <br />
                Maximum Discharge : {this.state.popup.highest} (cumecs)
              </div>
            </div>
          </ReactPopup>
        ) : null}
      </Map>
    );
  }
}

export default MapView;